import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const getAllGroups = async () => {
  //   const authState = getAuthenticationState();
  try {
    const resp = await apiClient.get(`/groups/showAllGroups`, {
      // headers: {
      //   authorization: `Bearer ${authState.token}`
      // }
    });

    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
